import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ImageResizer from '../../components/ImageResizer';

const ResizeImage: React.FC = () => (
  <ToolLayout
    title="Resize Image Online Free - Change Image Dimensions | AllTools"
    description="Resize images to any dimension online. Maintain aspect ratio, batch resize supported. Free image resizer tool."
    canonicalPath="/resize-image"
  >
    <ImageResizer />
  </ToolLayout>
);

export default ResizeImage;
